import { FileReader, FileWriter } from "@/platform";
import ModuleId from "./DataStructModuleId";

class ProjectHeader {

	public mid = ModuleId.projectHeader

	/**
	 * 工程ID号，32位
	 */
    public ID: string = "" 

	/**
	 * 创建工程的用户ID
	 */
    public UID: string = ""  

	/**
	 * 工程版本号
	 */
    public Version: number = 0  

	/**
	 * 创建时间
	 */
    public Time: string = ""   

	/**
	 * 工程是否是DEBUG模式下创建的
	 */
    public IsRelease: boolean = false 

	/**
	 * 工程绑定的路径名
	 */
    public projectPath: string = ""  

	readBin(reader: FileReader): void {
		this.ID = reader.readString()
		this.UID = reader.readString()
		this.Version = reader.readInt()
		this.Time = reader.readString()
		this.IsRelease = reader.readBool()
		this.projectPath = reader.readString()
	}

	writeBin(writer: FileWriter): void {
		writer.writeString(this.ID)
		writer.writeString(this.UID)
		writer.writeInt(this.Version)
		writer.writeString(this.Time)
		writer.writeBool(this.IsRelease)
		writer.writeString(this.projectPath)
	}
}

export default ProjectHeader;
